import { render, staticRenderFns } from "./manage_customer_tpl.vue?vue&type=template&id=71cb2fac&"
import script from "./manage_customer_tpl.vue?vue&type=script&lang=js&"
export * from "./manage_customer_tpl.vue?vue&type=script&lang=js&"
import style0 from "./manage_customer_tpl.vue?vue&type=style&index=0&id=71cb2fac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports